import React from 'react';
import { useTranslation } from 'react-i18next';
import './RestrictionsTab.scss';
import { RestrictionSet } from './RestrictionSet';
import { useRestrictionsTab } from '@/hooks/useRestrictionsTab';

interface RestrictionsTabProps {
  readonly: boolean;
  restrictions: RestrictionSet;
  toggleRestrictionsModal: any;
}

export default function RestrictionsTab({
  readonly,
  restrictions,
  toggleRestrictionsModal,
}: RestrictionsTabProps) {
  const { error, displayTerritoryRestrictions, territoryCount } =
    useRestrictionsTab(restrictions);
  const { t } = useTranslation();

  const openRestrictionsModal = () => {
    toggleRestrictionsModal();
  };

  return (
    <section className="restrictions-view">
      <div className="button-bar clearfix">
        <span className="restrictions-info-title">
          <span className="restrictions-info-title-strong">
            {error ? (
              <i className="icon fas fa-exclamation-triangle"></i>
            ) : null}
            <span>{t('product.restrictions.distributionTerritories')}</span>
          </span>
        </span>
        {!readonly ? (
          <button
            className="btn btn-primary alt float-end"
            onClick={() => openRestrictionsModal()}
          >
            <i className="icon fas fa-pencil"></i>
            <span>{t('product.restrictions.editRestrictions')}</span>
          </button>
        ) : (
          <button
            className="btn btn-primary alt float-end"
            onClick={() => openRestrictionsModal()}
          >
            <i className="icon fas fa-solid fa-list"></i>
            <span>{t('product.restrictions.viewRestrictions')}</span>
          </button>
        )}
      </div>

      <table className="restrictions-grid grid">
        <tbody>
          <tr className="restriction-detail-row">
            <td className="restriction-total-col">
              <span>{t('product.restrictions.territories')}</span>
              {territoryCount}
            </td>
            <td className="restriction-detail-col">
              <span className="restriction-details wrap-normal">
                <span>{displayTerritoryRestrictions}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
}
